export default __webpack_public_path__ + "media/images/stressful_situation-e4307c5106cd8ec69c7111c9ba1fcbb3.png";